import React from "react";
import { makeStyles } from "@material-ui/core";
import Page from "../components/Page";
import { useParams } from "react-router-dom";
import CommandDetailContainer from "../containers/mobile-frame/CommandDetailContainer";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
    [theme.breakpoints.down("xs")]: {
      paddingTop: theme.spacing(1),
    },
  },
}));

const CommandDetailPage = () => {
  const classes = useStyles();
  let { id, eklok } = useParams();
  console.log("eklok", eklok);
  console.log("id", id);

  return (
    <Page className={classes.root} title="Command Detail">
      <CommandDetailContainer commandId={id} eklok={eklok} />
    </Page>
  );
};

export default CommandDetailPage;
